export * from './avatars.module';